export default __webpack_public_path__ + "static/cashmartLogo-7f336e423ad62babb993868933c35a7b.png";